module.exports = __webpack_public_path__ + "static/media/WAIDA.9ca08fff.mp4";